export default __webpack_public_path__ + "static/media/bg-pattern-left.5db62c6d.png";